import * as Tone from 'tone'
import Instruments from './utils/Sounds'
import helpers from './utils/helpers'
import EventEmitter from './utils/EventEmitter'
import CONSTANTS from './utils/config'
class HearingTestPreparation {
  
  constructor (numStages) {
    this.numStages = numStages
    this.correctAnswers = 0
    this.instruments = Instruments.instruments
    this.instrumentsCategories = Instruments.categorized
    this.stages = CONSTANTS.HEARING_TEST.INSTRUMENTS_DECIBEIS
    this.answers = []
    this.currentStage = 0
    this.eventEmitter = new EventEmitter()
    this.questions = this.buildQuestions()
    this.player = null
    this.tries = 0
    this.currentInstrument = null
    this.isPlaying = false
  }

  buildQuestions () {
    return this.instruments.concat().sort(() => 0.5 - Math.random()).slice(0, 3)
  }
  
  init () {
    this.playInstructions()
    this.eventEmitter.emit('instructionsStarted')
    setTimeout(() => {
      this.eventEmitter.emit('instructionsEnded')
      this.playLevel()
    }, 6300)
  }

  playLevel () {

    let instrument = this.questions[this.currentStage]

    this.currentInstrument = instrument.name

    let volume = this.stages[this.currentStage]
    this.isPlaying = true
    this.play(instrument, volume)
  }

  playInstructions () {
    new Tone.Player({
      url: './public/ajuste_volume.mp3',
      autostart: true,
      loop: false,
      volume: CONSTANTS.HEARING_TEST.INSTRUCTIONS_DECIBEIS
    }).toDestination()
  }
  
  play (instrument, volume) {
    this.isPlaying = true
    if (this.player !== null) {
      this.player.disconnect()
    }
    this.player = new Tone.Player({
      url: `./public/${instrument.audio}.mp3`,
      autostart: true,
      loop: true,
      volume
    }).toDestination()
  }

  playCurrentStage () {
    setTimeout(() => {
      this.playLevel()
    }, 750)
  }
  
  evaluate (answer) {
    if (this.isPlaying) {
      this.player.stop()
      if (this.currentInstrument !== answer) {
        this.isPlaying = false
        this.eventEmitter.emit('answer-result', {instrument: answer, result: false})
        this.tries ++
      } else {
        this.eventEmitter.emit('answer-result', {instrument: answer, result: true})
        this.currentStage += 1
      }

      if (this.currentStage <= this.stages.length - 1) {
        this.playCurrentStage()
      } else {
        setTimeout(() => {
          this.eventEmitter.emit('firstStageEnded', this.tries)
        }, 1000)
        console.log('First stage ended with wrong tries: ', this.tries)
      }
    }
  }
}

export default HearingTestPreparation